export default __webpack_public_path__ + "static/media/img_4682(1).471bcdb8.jpg";